import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLang } from "./lang";
import { company } from "./data";

export const links = [
  ["/", "หน้าแรก", "Home"],
  ["/products", "ผลิตภัณฑ์", "Products"],
  ["/about", "เกี่ยวกับเรา", "About"],
  ["/contact", "ติดต่อเรา", "Contact"],
];

function NavigationBar() {
  const { t, isEng, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const item = ({ isActive }) =>
    `block rounded-md px-3 py-2 font-medium ${isActive ? "text-gws-blue" : "text-ink-soft hover:text-ink"}`;

  return (
    <header className="sticky top-0 z-40 border-b border-steel-200 bg-white/95 backdrop-blur">
      <div className="wrap flex h-16 items-center gap-4">
        <Link to="/" className="flex shrink-0 items-center gap-3" aria-label={t(company.name)}>
          <img src="/logo192.png" alt="" width="44" height="44" className="h-11 w-11 object-contain" />
          <span className="hidden text-sm font-semibold leading-tight sm:block">
            GWS Research
            <br />& Development
          </span>
        </Link>

        <nav className="ml-auto hidden md:block" aria-label="Main">
          <ul className="flex items-center gap-1">
            {links.map(([to, th, en]) => (
              <li key={to}>
                <NavLink to={to} end className={item}>{t(th, en)}</NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <button
          onClick={toggle}
          className="ml-auto rounded-md border border-steel-200 px-3 py-1.5 text-sm font-semibold md:ml-0"
          aria-label={isEng ? "เปลี่ยนเป็นภาษาไทย" : "Switch to English"}
        >
          {isEng ? "TH" : "EN"}
        </button>
        <a href={`tel:${company.tel}`} className="btn-primary hidden py-2 lg:inline-flex">
          {company.phone}
        </a>

        <button
          className="rounded-md p-2 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={t("เมนู", "Menu")}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </div>

      {open && (
        <nav id="mobile-nav" className="border-t border-steel-200 bg-white md:hidden" aria-label="Mobile">
          <ul className="wrap py-2">
            {links.map(([to, th, en]) => (
              <li key={to}>
                <NavLink to={to} end className={item}>{t(th, en)}</NavLink>
              </li>
            ))}
            <li className="py-2">
              <a href={`tel:${company.tel}`} className="btn-primary w-full">
                {t("โทร", "Call")} {company.phone}
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}

export default NavigationBar;
